module.exports = __webpack_public_path__ + "static/media/bistro.0f001b4b.jpg";